import { useOutletContext } from "react-router-dom";
import { Grid } from "@mui/material";
import { Initiative } from "~/operations";
import { SpaceOrWorkspaceScope, SpaceScope } from "~/hooks/useScope";
import { EmptySection } from "~/components/vulnerabilities";
import { Loading, LoadingFailed } from "~/components/loading";
import { Flex } from "~/components/Flex";
import { NoMatchFilters } from "~/pages/inventory/components/EmptyState";
import { ChecklistIcon } from "~/icons";
import { useInitiativeFindings } from "./hooks/useInitiativeFindings";
import { FirewatchList } from "~/components/FirewatchList/FirewatchList";

interface InitiativeDetailOutletContext {
  initiative: Initiative;
  scope: SpaceOrWorkspaceScope;
  spaceScope: SpaceScope;
}

export function InitiativeFindingsTab() {
  const { initiative, scope, spaceScope } =
    useOutletContext<InitiativeDetailOutletContext>();

  const {
    loading,
    error,
    edges,
    pageInfo,
    sort,
    paginate,
    filterForm,
    activeFilterCount,
    resetFilters,
  } = useInitiativeFindings({
    initiativeMrn: initiative.mrn,
  });

  if (error) {
    return <LoadingFailed what="findings" />;
  }

  if (loading && !edges.length) {
    return <Loading what="findings" />;
  }

  const hasFindings = (edges?.length || 0) > 0;

  return (
    <Grid id="initiative-findings" size={12}>
      <Flex flexDirection="column">
        {(hasFindings || (!hasFindings && activeFilterCount > 0)) && (
          <Grid size={12} sx={{ mb: 3 }}>
            {filterForm}
          </Grid>
        )}
        {hasFindings ? (
          <FirewatchList
            space={spaceScope}
            scope={scope}
            pageType="AllSecurityFindings"
            loading={loading}
            data={edges}
            sort={sort}
            paginateProps={paginate.pageProps(pageInfo)}
          />
        ) : (
          <>
            {activeFilterCount > 0 ? (
              <NoMatchFilters
                title="No findings match your filter selection"
                icon={
                  <ChecklistIcon sx={{ fontSize: 38, color: "primary.main" }} />
                }
                content={`Out of the findings, none match the filters you selected. Reset them to reveal all findings.`}
                onClick={() => {
                  resetFilters();
                }}
              />
            ) : (
              <EmptySection
                id="initiative-findings-list-empty"
                text="There are currently no findings for this initiative."
              />
            )}
          </>
        )}
      </Flex>
    </Grid>
  );
}
